import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiClient from "../../config/AppAdmin";

const initialState = {
  isLoading: false,
  error: null,
  subscriptionList: [],
};


// Fetch all Subscriptions
export const fetchScriptionList = createAsyncThunk(
    "subscription/fetchScriptionList",
    async (_, { rejectWithValue }) => {
      try {
        const response = await ApiClient.get("/subscription");
        // Check success properly
        if (response.data.success === true) return response.data.data[0];
        throw new Error("Failed to fetch Subscriptions");
      } catch (err) {
        return rejectWithValue(err?.response?.data?.message || err.message);
      }
    }
  );
  

// Delete Subscription
export const deletesubscription = createAsyncThunk(
  "subscription/deletesubscription",
  async (subscription_id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.delete(`/subscription/${subscription_id}`);
      if (response.status === 200) return  subscription_id;
      throw new Error("Failed to delete subscription");
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message);
    }
  }
);

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    addsubscription: (state, action) => {
      state.subscriptionList.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchScriptionList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchScriptionList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionList = action.payload;
      })
      .addCase(fetchScriptionList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // Delete
      .addCase(deletesubscription.fulfilled, (state, action) => {
        state.subscriptionList = state.subscriptionList.filter(
          (d) => d.subscription_id !== action.payload
        );
      })
      .addCase(deletesubscription.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { addsubscription} = subscriptionSlice.actions;
export default subscriptionSlice.reducer;